<template>
	<div class="content">
		<div class="main_content">
			<div class="content_left">
				<div class="left_title" @click="titleClick">
					<div class="left_title_icon">
						<div v-show="showNavFlag" class="left_title_icon_tri_on"></div>
						<div v-show="!showNavFlag" class="left_title_icon_tri_off"></div>
					</div>
					<div class="left_title_text">我的收藏</div>
				</div>
				<transition enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
					<div v-show="showNavFlag" class="left_tabs">
						<div class="left_nav" @click='getCollections'>
							<div class="nav_content" :class="activeNav == 'all'? 'navActive': ''">
								<div class="nav_text">所有收藏题({{totalNum}})</div>
							</div>
						</div>
						<div class="left_nav" @click="clearCollectionList">
							<div class="nav_content" :class="activeNav == 'clear'? 'navActive': ''">
								<div class="nav_text">清空所有收藏题</div>
							</div>
						</div>
					</div>
				</transition>
			</div>
			<div class="content_right">
				<div class="right_top" v-if="totalNum == 0">
					<div class="topic_type">
						<div class="type_text">暂无收藏题目</div>
					</div>
				</div>
				<div class="right_top" v-else>
					<div class="topic_type">
						<div class="type_text" v-if="collectionDetail.question_info.type == 1">单选题</div>
						<div class="type_text" v-else-if="collectionDetail.question_info.type == 2">多选题</div>
						<div class="type_text" v-else-if="collectionDetail.question_info.type == 3">判断题</div>
						<div class="type_line"></div>
					</div>
					<div class="topic_content">
						<div class="topic_title" v-html="collectionDetail.question_info.title">{{collectionDetail.question_info.title}}</div>
						<div class="topic_answers" v-show="collectionDetail.question_info.type == 1">
							<div class="answer_content" v-for="(item,index) in collectionDetail.question_info.options" :key="index" @click="checkRadio(index)">
								<div class="answer_icon" :class="{'answerChecked':item.isChecked}"></div>
								<div class="answer_text">{{letterList[index]}}.{{item.options}}</div>
							</div>
						</div>
						<div class="topic_answers" v-show="collectionDetail.question_info.type == 2">
							<div class="answer_content" v-for="(item,index) in  collectionDetail.question_info.options" :key="index" @click="checkBox(index)">
								<div class="answer_icon" :class="{'answerChecked':item.isChecked}"></div>
								<div class="answer_text">{{letterList[index]}}.{{item.options}}</div>
							</div>
						</div>
						<div class="topic_answers" v-show="collectionDetail.question_info.type == 3">
							<div class="answer_content" v-for="(item,index) in collectionDetail.question_info.options" :key="index" @click="checkJudje(index)">
								<div class="answer_icon" :class="{'answerChecked':index == judjeIndex}"></div>
								<div class="answer_text">{{item}}</div>
							</div>
						</div>
					</div>
					<div class="topic_result" v-if="showAnswerFlag">
						<div class="result_your">【你的答案】<span>{{questionResult.youser_answer}}</span></div>
						<div class="result_true">【正确答案】{{questionResult.right_answer}}</div>
						<div class="result_analysis">
							<p>【答案解析】</p>
							<p v-html="questionResult.analysis">{{questionResult.analysis}}</p>
						</div>
					</div>
					<div class="topic_operation">
						<div class="operation_left">
							<div class="operation_btn pre_topic" @click="prevQuestion">上一题</div>
							<div class="operation_btn next_topic" @click="nextQuestion">下一题</div>
						</div>
						<div class="operation_right">
							<div class="operation_btn operation_topic" @click="getAnswer">答案</div>
							<div class="operation_btn next_topic" @click="cancelcollectTopic">已收藏</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { getCollectionList } from '@/api/paper.js'
	import { deleteCollection } from '@/api/paper.js'
	import { clearCollection } from '@/api/paper.js'
	import { getQuestionResult } from '@/api/paper.js'
	export default {
		name: 'collection',
		data() {
			return {
				collectionListData:{
					token: '',
					user_id: '',
					page: 1,
					limit: 1
				},
				collectionDetail:{},
				collectionNum: 1,
				totalNum: 0,
				collectionRequestData:{
					token: '',
					user_id: '',
					question_id: ''
				},
				showNavFlag: true,
				letterList:['A','B','C','D','E','F','G','H','I','J'],
				judjeIndex: 100,
				resultRequestData:{
					token: '',
					question_id: '',
					answer: ''
				},
				questionResult: {},
				showAnswerFlag: false,
				activeNav: 'all',
				clearRequestData:{
					token: '',
					user_id: ''
				}
			}
		},
		mounted() {
			let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
			this.collectionListData.token = window.localStorage.getItem("token");
			this.collectionListData.user_id = userInfo.user_id;
			this.collectionRequestData.token = window.localStorage.getItem("token");
			this.collectionRequestData.user_id = userInfo.user_id;
			this.resultRequestData.token = window.localStorage.getItem("token");
			this.clearRequestData.token = window.localStorage.getItem("token");
			this.clearRequestData.user_id = userInfo.user_id;
			this.getCollections();
		},
		methods: {
			//我的收藏点击
			titleClick(){
				this.showNavFlag = !this.showNavFlag;
			},
			//所有收藏题
			getCollections(){
				this.activeNav = 'all';
				let that = this;
				let data = this.collectionListData;
				getCollectionList(data).then(res =>{
					if(res.code == 0){
						that.totalNum = res.data.total;
						that.collectionDetail = res.data.data[0];
					}else{
						that.$message.error(res.message);
					}
				})
			},
			//清空收藏
			clearCollectionList(){
				this.activeNav = 'clear';
				let that = this;
				let data = this.clearRequestData;
				this.$confirm('确认清空收藏吗?', '提示', {

				}).then(() => {
					clearCollection(data).then(res =>{
						if(res.code == 0){
							that.getCollections();
							that.$message.success(res.message);
						}else{
							that.$message.error(res.message);
						}
					})
				}).catch(() => {

				});
			},
			//上一题
			prevQuestion(){
				if(this.collectionNum == 1){
					this.$message.error('已经是第一题了~');
					return
				}
				this.showAnswerFlag = false;
				this.judjeIndex = 100;
				this.collectionNum = this.collectionNum - 1;
				this.collectionListData.page = this.collectionListData.page -1;
				this.getCollections();
			},
			//下一题
			nextQuestion(){
				if(this.collectionNum == this.totalNum){
					this.$message.error('已经是最后一道题了！');
					return
				}
				this.showAnswerFlag = false;
				this.judjeIndex = 100;
				this.collectionNum = this.collectionNum + 1;
				this.collectionListData.page = this.collectionListData.page +1;
				this.getCollections();
			},
			//单选
			checkRadio(index) {
				let options = this.collectionDetail.question_info.options;
				options.forEach((item) => {
					item.isChecked = false;
				});
				this.collectionDetail.question_info.options[index].isChecked = true;
				this.$forceUpdate();
			},
			//多选
			checkBox(index) {
				let options = this.collectionDetail.question_info.options;
				if(options[index].isChecked){
					this.collectionDetail.question_info.options[index].isChecked = false;
				}else{
					this.collectionDetail.question_info.options[index].isChecked = true
				}
				this.$forceUpdate()
			},
			//判断
			checkJudje(index){
				this.judjeIndex = index;
				let question_options = this.collectionDetail.question_info.options;
				this.collectionDetail.question_info.judgeanswerText = question_options[index];
				this.$forceUpdate()
			},
			//答案
			getAnswer(){
				let that = this;
				let my_answer = [];
				let options = this.collectionDetail.question_info.options;
				if(this.collectionDetail.question_info.type == 3){
					if(this.collectionDetail.question_info.judgeanswerText){
						my_answer.push(this.collectionDetail.question_info.judgeanswerText);
					}
				}else{
					options.forEach((item) => {
						if(item.isChecked){
							my_answer.push(item.options)
						}
					});
				}
				
				if(my_answer.length == 0){
					this.$message.error('请先作答再查看答案！')
				}else{
					this.showAnswerFlag = !this.showAnswerFlag;
					this.resultRequestData.question_id = this.collectionDetail.question_id;
					this.resultRequestData.answer = my_answer.join(',');
					let data = this.resultRequestData;
					getQuestionResult(data).then(res =>{
						if(res.code == 0){
							that.questionResult = res.data;
						}else{
							that.$message.error(res.message);
						}
					})
				}
			},
			//取消收藏
			cancelcollectTopic(){
				let that = this;
				this.collectionRequestData.question_id = this.collectionDetail.question_id;
				let data = this.collectionRequestData;
				deleteCollection(data).then(res =>{
					if(res.code == 0){
						that.$message.success('取消收藏成功！');
						if(that.collectionNum == that.totalNum && that.totalNum > 1){
							that.collectionNum = that.collectionNum - 1;
							that.collectionListData.page = that.collectionListData.page -1;
						}
						that.getCollections();
					}else{
						that.$message.error(res.message);
					}
				})
			}
		},
	}
</script>

<style scoped>
	.content{
		width: 100%;
		height: calc(100% - 210px);
		background-color: #f1f1f1;
		padding: 115px 0 15px;
	}
	.main_content{
		width: 1210px;
		height: 100%;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		overflow-y: scroll;
		overflow-x: hidden;
	}
	.content_left{
		width: 298px;
		height: auto;
		min-height: calc(100% - 2px);
		border: 1px solid #d7d7d7;
		background-color: #fefefe;
		display: flex;
		flex-direction: column;
	}
	.content_left .left_title{
		width: 298px;
		height: 53px;
		background-color: #8e0001;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
		position: relative;
		z-index: 9;
	}
	.content_left .left_title .left_title_icon{
		width: 24px;
		height: 24px;
		background-color: #a7051c;
		border-radius: 50%;
		margin-left: 26px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
	}
	.content_left .left_title .left_title_icon .left_title_icon_tri_on{
		width: 10px;
		height: 6px;
		background-image: url('../assets/images/tri_on.png');
	}
	.content_left .left_title .left_title_icon .left_title_icon_tri_off{
		width: 6px;
		height: 10px;
		background-image: url('../assets/images/tri_off.png');
	}
	.content_left .left_title .left_title_text{
		font-size: 18px;
		color: #ffffff;
		margin-left: 18px;
	}
	.content_left .left_tabs{
		width: 298px;
		height: auto;
		display: flex;
		flex-direction: column;
	}
	.fadeInDown {
		animation: .8s animationIn;
	}

	@keyframes animationIn {
		0% {
			transform: translateY(-100%)
		}
		100% {
			transform: translateY(0)
		}
	}
	.fadeOutUp{
		animation: .8s animationOut;
	}
	@keyframes animationOut{
		0% {
			transform: translateY(0)
		}
		100% {
			transform: translateY(-100%)
		}
	}
	.content_left .left_tabs .left_nav{
		width: 298px;
		height: auto;
		background-color: #ffffff;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		border-bottom: 1px solid #d7d7d7;
	}
	.content_left .left_tabs .left_nav .nav_content{
		width: 298px;
		height: 50px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		cursor: pointer;
	}
	.content_left .left_tabs .nav_content:last-child{
		border-bottom: none;
	}
	.content_left .left_tabs .nav_content .nav_text{
		width: 200px;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		color: #343434;
		text-align: left;
		margin-left: 68px;
	}
	.content_left .left_tabs .nav_content.navActive{
		background-color: #b93132;
	}
	.content_left .left_tabs .nav_content.navActive .nav_text{
		color: #f7fffe;
	}
	.content_right{
		width: 884px;
		height: auto;
		display: flex;
		flex-direction: column;
		margin-left: 15px;
	}
	.right_top{
		width: 884px;
		height: auto;
		border: 1px solid #d7d7d7;
		background-color: #fefefe;
		margin-bottom: 15px;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 14px 0 29px;
	}
	.right_top .topic_type{
		width: 833px;
		height: 45px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		margin-bottom: 22px;
	}
	.right_top .topic_type .type_text{
		width: 833px;
		height: 43px;
		line-height: 43px;
		font-size: 18px;
		color: #030303;
		text-align: left;
	}
	.right_top .topic_type .type_line{
		width: 28px;
		height: 2px;
		background-color: #d7112c;
	}
	.right_top .topic_finish{
		width: 833px;
		height: auto;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		text-align: left;
		margin-bottom: 47px;
	}
	.right_top .topic_finish .finish_result{
		width: 833px;
		height: 64px;
		line-height: 64px;
		color: #474747;
		font-size: 14px;
	}
	.right_top .topic_finish .finish_btn{
		width: 107px;
		height: 33px;
		background-color: #5277d4;
		line-height: 33px;
		text-align: center;
		color: #ffffff;
		font-size: 14px;
		cursor: pointer;
	}
	.right_top .topic_content{
		width: 833px;
		/* height: auto; */
		height: 260px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		text-align: left;
		margin-bottom: 47px;

	}
	.right_top .topic_content .topic_title{
		width: 833px;
		height: auto;
		line-height: 22px;
		font-size: 14px;
		color: #3e3e3e;
		margin-bottom: 22px;
	}
	.right_top .topic_content .topic_answers{
		width: 833px;
		height: auto;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		text-align: left;
	}
	.right_top .topic_content .topic_answers .answer_content{
		width: 833px;
		height: auto;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		cursor: pointer;
	}
	.right_top .topic_content .topic_answers .answer_content .answer_icon{
		width: 12px;
		height: 12px;
		margin: 12px 18px 0 8px;
		background-image: url('../assets/images/select.png');
	}
	.right_top .topic_content .topic_answers .answer_content .answer_icon.answerChecked{
		background-image: url('../assets/images/selected.png');
	}
	.right_top .topic_content .topic_answers .answer_content .answer_text{
		width: 795px;
		height: auto;
		font-size: 12px;
		color: #5c656a;
		line-height: 34px;
	}
	.right_top .topic_result{
		width: 783px;
		height: auto;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		text-align: left;
	}
	.right_top .topic_result .result_your{
		width: 783px;
		height: 24px;
		line-height: 24px;
		font-size: 14px;
		color: #2b3537;
		margin-bottom: 24px;
	}
	.right_top .topic_result .result_your span{
		color: #e1512e;
	}
	.right_top .topic_result .result_true{
		width: 783px;
		height: 24px;
		line-height: 24px;
		font-size: 14px;
		color: #2b3537;
		margin-bottom: 24px;
	}
	.right_top .topic_result .result_analysis{
		width: 783px;
		height: auto;
		line-height: 24px;
		font-size: 14px;
		color: #2b3537;
		margin-bottom: 24px;
	}
	.right_top .topic_result .result_analysis p{
		margin: 0
	}
	.right_top .topic_operation{
		width: 833px;
		height: 66px;
		border-top: 1px solid #e1e1e1;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-between;
	}
	.right_top .topic_operation .operation_btn{
		width: 107px;
		height: 32px;
		margin-left: 14px;
		line-height: 32px;
		font-size: 14px;
		cursor: pointer;
	}
	.right_top .topic_operation .operation_left{
		width: 246px;
		height: 34px;
		margin-top: 32px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
	}
	.right_top .topic_operation .operation_left .pre_topic{
		border:1px solid #e0e0e0;
		color: #61646b;
	}
	.right_top .topic_operation .next_topic{
		background-color: #ff8d31;
		border:1px solid #ff8d31;
		color: #f8ffff;
	}
	.right_top .topic_operation .operation_right{
		width: 246px;
		height: 34px;
		margin-top: 32px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-end;
	}
	.right_top .topic_operation .operation_right .operation_topic{
		background-color: #ff9a64;
		border:1px solid #ff9a64;
		color: #f8ffff;
	}
	.main_content::-webkit-scrollbar {
		width: 8px;
	}
	.main_content::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 8px;
		box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2);
		-webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.02);
		background: #e2e2e2;
	}
	.main_content::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.2);
		-webkit-box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.01);
		border-radius: 8px;
		background: #f1f1f1;
	}
</style>
